import validate from "/Users/mauriciomateus/sites/ipa-lms/node_modules/nuxt/dist/pages/runtime/validate.js";
import _001_45portal_45redirect_45global from "/Users/mauriciomateus/sites/ipa-lms/middleware/001-portal-redirect.global.ts";
import auth_45global from "/Users/mauriciomateus/sites/ipa-lms/middleware/auth.global.ts";
import breadcrumb_45tracker_45global from "/Users/mauriciomateus/sites/ipa-lms/middleware/breadcrumb-tracker.global.ts";
import manifest_45route_45rule from "/Users/mauriciomateus/sites/ipa-lms/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _001_45portal_45redirect_45global,
  auth_45global,
  breadcrumb_45tracker_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "chukkers-guard": () => import("/Users/mauriciomateus/sites/ipa-lms/middleware/chukkers-guard.ts"),
  "feature-flag-guard-utils": () => import("/Users/mauriciomateus/sites/ipa-lms/middleware/featureFlagGuardUtils.ts"),
  "gallery-guard": () => import("/Users/mauriciomateus/sites/ipa-lms/middleware/gallery-guard.ts"),
  "leaderboard-guard": () => import("/Users/mauriciomateus/sites/ipa-lms/middleware/leaderboard-guard.ts"),
  "staging-only": () => import("/Users/mauriciomateus/sites/ipa-lms/middleware/staging-only.ts"),
  "tournaments-guard": () => import("/Users/mauriciomateus/sites/ipa-lms/middleware/tournaments-guard.ts")
}